import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
    // The shared `paperFullScreen` dialog style center-aligns its content, which
    // otherwise lets this flex root shrink below the viewport width. Force it to
    // fill so the world map spans the full dialog width.
    width: "100%",
  },
  sidebar: {
    flex: "0 0 288px",
    display: "flex",
    flexDirection: "column",
    background: theme.palette.grey[100],
  },
  sidebarHeader: {
    padding: "24px 24px 8px 24px",
  },
  sidebarBody: {
    flex: "1",
    overflow: "auto",
    padding: "0 24px 24px 24px",
    scrollbarColor: "#aaa transparent",
    scrollbarWidth: "thin",
    "&::-webkit-scrollbar": {
      width: 4,
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.palette.grey[500],
    },
  },
  content: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    width: "calc(100% - 288px)",
    padding: 24,
  },
  contentHeader: {
    display: "flex",
  },
  contentTitle: {
    flex: "1",
  },
  contentClose: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.grey[900],
    "& svg": {
      marginLeft: 8,
    },
  },
  contentBody: {
    flex: "1",
    display: "flex",
    alignItems: "center",
  },
  contentFooter: {
    display: "flex",
    alignItems: "center",
  },
  contentLegend: {
    flex: "1",
    display: "flex",
    alignItems: "center",
    marginLeft: 16,
  },
  contentActions: {
    paddingRight: 80,
  },
}));
